import type React from 'react'

export type ChevronProps = {
  direction: 'left' | 'right' | 'up' | 'down'
  color?: string
}

const Chevron: React.FC<ChevronProps> = ({ direction }) => {
  let pathData = ''

  switch (direction) {
    case 'left':
      pathData = 'M11 2L6 8L11 14'
      break
    case 'right':
      pathData = 'M5 2L10 8L5 14'
      break
    case 'up':
      pathData = 'M2 11L8 6L14 11'
      break
    case 'down':
      pathData = 'M2 5L8 10L14 5'
      break
    default:
      pathData = ''
      break
  }

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={pathData}
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Chevron
